export default __webpack_public_path__ + "static/media/new-advanced-settings.8adc629b.svg";